import React from 'react'

const FtrMyAccountLinks = () => {
    return (
        <>
            <div className="footer-column clearfix">
                <h3>My Account</h3>
                <ul className="footer-menu-last">
                    <a href="/">Log In</a>
                    <a href="/">Sign Up</a>
                </ul>
            </div>           
        </>
    )
}

export default FtrMyAccountLinks;